(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop >= 10) {
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader); 

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  function initRecommendationsSlider(scope) {
    var $scope = scope ? $(scope) : $(document);
    var $sliders = $scope.find(".product-recommendations-slider");

    if (!$sliders.length) return;

    $sliders.each(function () {
      var $slider = $(this);

      // If already initialized, destroy first (prevents grid/broken style on reload/AJAX)
      if ($slider.hasClass("slick-initialized")) {
        $slider.slick("unslick");
      }

      $slider.slick({
        lazyLoad: 'ondemand',
        dots: false,
        infinite: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipe: true,
        speed: 500,
        adaptiveHeight: true,
        prevArrow:'<button class="slide-arrow prev-arrow" aria-label="Prev"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" viewBox="0 0 256 256" xml:space="preserve"><g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"><path d="M 65.75 90 c 0.896 0 1.792 -0.342 2.475 -1.025 c 1.367 -1.366 1.367 -3.583 0 -4.949 L 29.2 45 L 68.225 5.975 c 1.367 -1.367 1.367 -3.583 0 -4.95 c -1.367 -1.366 -3.583 -1.366 -4.95 0 l -41.5 41.5 c -1.367 1.366 -1.367 3.583 0 4.949 l 41.5 41.5 C 63.958 89.658 64.854 90 65.75 90 z" style="fill: rgb(0,0,0);"/></g></svg></button>',
        nextArrow:'<button class="slide-arrow next-arrow" aria-label="Next"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-caret" viewBox="0 0 256 256" xml:space="preserve"><g transform="translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"><path d="M 24.25 90 c -0.896 0 -1.792 -0.342 -2.475 -1.025 c -1.367 -1.366 -1.367 -3.583 0 -4.949 L 60.8 45 L 21.775 5.975 c -1.367 -1.367 -1.367 -3.583 0 -4.95 c 1.367 -1.366 3.583 -1.366 4.95 0 l 41.5 41.5 c 1.367 1.366 1.367 3.583 0 4.949 l -41.5 41.5 C 26.042 89.658 25.146 90 24.25 90 z" style="fill: rgb(0,0,0);"/></g></svg></button>',
        responsive: [
          {
            breakpoint: 1024,
            settings: { slidesToShow: 3, slidesToScroll: 1, dots: false }
          },
          {
            breakpoint: 600,
            settings: { slidesToShow: 2, slidesToScroll: 1 }
          },
          {
            breakpoint: 480,
            settings: { slidesToShow: 1, slidesToScroll: 1 }
          }
        ]
      });
    });
  }

  // Your existing ProductRecommendations loader
  ProductRecommendations = (function () {
    function ProductRecommendations() {
      this.$container = $('#productRecommendationsSection');

      if (!this.$container.length) return;

      const self = this;
      const productId = this.$container.data("productId");
      const sectionId = this.$container.data("sectionId");
      const recommendationsURL = this.$container.data("sectionUrl");
      const limit = this.$container.data("limit");

      const recommendationsSectionUrl =
        `${recommendationsURL}?&section_id=${sectionId}&product_id=${productId}&limit=${limit}`;

      $.get(recommendationsSectionUrl).then(function (section) {
        const parsedMarkup = new DOMParser().parseFromString(section, "text/html");
        const recommendationsMarkup = parsedMarkup.querySelector(".product-recommendations");

        if (recommendationsMarkup) {
          self.$container.html(recommendationsMarkup);

          // ✅ init slick AFTER HTML injected
          initRecommendationsSlider(self.$container);

          // keep your event too
          theme.cache.$body.trigger("afterRecommendationLoad");
        }
      });
    }
    return ProductRecommendations;
  })();

  // Run on page load
  document.addEventListener("DOMContentLoaded", function () {
    initRecommendationsSlider(document);
    ProductRecommendations();
  });

  // Theme editor support
  document.addEventListener("shopify:section:load", function (event) {
    initRecommendationsSlider(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
